
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import CrmActiveFilters from "@/modules/CRM/components/CrmActiveFilters";
import CrmDealCard from "@/modules/CRM/components/CrmDealCard";
import CrmEmptyState from "@/modules/CRM/components/CrmEmptyState";
import CrmToolbar from "@/modules/CRM/components/CrmToolbar";
import crmService from "@/modules/CRM/services/crmService";
import { SistemaMixin, priceOptions } from "@/modules/Application";
import { Money } from "v-money";

const KANBAN_LIMIT = 30;
const LAST_FUNNEL_STORAGE_KEY = "crm.funil.ultimo_id";

export default {
  name: "crm-funil",
  components: {
    BuscaClienteContato,
    CrmActiveFilters,
    CrmDealCard,
    CrmEmptyState,
    CrmToolbar,
    Money,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      buscaTimer: null,
      priceOptions,
      funis: [],
      fontes: [],
      agendaDrawerVisible: false,
      filtersDrawerVisible: false,
      kanban: null,
      kanbanError: "",
      kanbanScrollWidth: 0,
      kanbanScrollSyncing: false,
      loading: false,
      loadingAgendaHorarios: false,
      loadingConsultaCepFechamento: false,
      loadingConsultaCnpjFechamento: false,
      loadingEtapas: {},
      savingOportunidade: false,
      agendaHorarios: null,
      agendaHorariosErro: "",
      motivosPerda: [],
      temperaturaOptions: [
        { value: null, text: "Sem temperatura" },
        { value: "muito_frio", text: "Muito frio" },
        { value: "frio", text: "Frio" },
        { value: "morno", text: "Morno" },
        { value: "quente", text: "Quente" },
        { value: "venda_certa", text: "Venda certa" },
      ],
      tiposTarefa: [],
      usuarios: [],
      vendedoresAtribuicao: [],
      desenvolvedoresAtribuicao: [],
      treinamentoAtribuicao: [],
      filtros: this.filtrosPadrao(),
      dragState: this.emptyDragState(),
      agendaForm: this.emptyAgendaForm(),
      form: this.emptyForm(),
      notaForm: this.emptyNotaForm(),
      vinculoSelecionado: null,
      oportunidadeSelecionada: {},
      temperaturaForm: {
        temperatura: null,
      },
      dadosNegociacao: this.emptyDadosNegociacao(),
      idEtapaDestino: null,
      idUsuarioTecnicoDestino: null,
      idUsuarioDestino: null,
      concederAcessoFunilDestino: false,
      movimentoCamposForm: {},
      movimentoManterValor: true,
      perda: this.emptyPerda(),
      ganho: this.emptyGanho(),
      tarefaForm: this.emptyTarefaForm(),
      tarefaAgendamentoOrigem: null,
      tarefaDrawerVisible: false,
      wizardStep: 0,
      wizardSteps: [
        { key: "titulo", label: "Nome" },
        { key: "contato", label: "Contato" },
        { key: "comercial", label: "Dados" },
        { key: "confirmacao", label: "Confirmar" },
      ],
      tipoAgendaOptions: [
        { value: "follow_up", text: "Follow-up" },
        { value: "reuniao", text: "Reunião" },
        { value: "visita", text: "Visita" },
        { value: "demonstracao", text: "Demonstração" },
        { value: "treinamento", text: "Treinamento" },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
        { value: "outro", text: "Outro" },
      ],
      periodoAtividadeOptions: [
        { value: "Todos", text: "Todas" },
        { value: "hoje", text: "Hoje" },
        { value: "atrasadas", text: "Atrasadas" },
        { value: "proximas", text: "Próximos 7 dias" },
        { value: "sem_atividade", text: "Sem próxima tarefa" },
      ],
      statusOptions: [
        { value: "aberta", text: "Abertas" },
        { value: "Todos", text: "Todos" },
        { value: "ganha", text: "Ganhas" },
        { value: "perdida", text: "Perdidas" },
      ],
      beneficioOptions: [
        { value: "website", text: "Website" },
        {
          value: "implementacao_white_label",
          text: "Implementação White Label",
        },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.form.id_crm_oportunidade
        ? "Editar oportunidade"
        : "Nova oportunidade";
    },
    funilOptions() {
      return [{ value: null, text: "Funil padrão" }].concat(
        this.funilOptionsSemTodos
      );
    },
    funisNavegacao() {
      return this.funis
        .map((funil) => ({
          value: funil.id_crm_funil,
          text: funil.nome,
          ordem: Number(funil.ordem || 0),
        }))
        .sort((a, b) => a.ordem - b.ordem || a.text.localeCompare(b.text));
    },
    funilOptionsSemTodos() {
      return this.funisNavegacao.map((funil) => ({
        value: funil.value,
        text: funil.text,
      }));
    },
    funilAtualId() {
      if (this.filtros.id_crm_funil) {
        return this.filtros.id_crm_funil;
      }

      return this.kanban && this.kanban.funil
        ? this.kanban.funil.id_crm_funil
        : null;
    },
    funilAtual() {
      return (
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null)
      );
    },
    funilAtualClienteFinal() {
      return (
        this.funilAtual &&
        this.funilAtual.chave_preset === "vendas_cliente_final"
      );
    },
    usuarioOptions() {
      return [{ value: null, text: "Todos" }].concat(
        this.usuarioOptionsSemTodos
      );
    },
    usuarioOptionsSemTodos() {
      return this.usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    vendedorResponsavelOptions() {
      const vendedores = this.vendedoresAtribuicao.length
        ? this.vendedoresAtribuicao
        : this.usuarios;

      return vendedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    desenvolvedorResponsavelOptions() {
      const desenvolvedores = this.desenvolvedoresAtribuicao.length
        ? this.desenvolvedoresAtribuicao
        : this.usuarios;

      return desenvolvedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    treinamentoResponsavelOptions() {
      const usuarios = this.treinamentoAtribuicao.length
        ? this.treinamentoAtribuicao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    agendaResponsavelOptions() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? this.treinamentoResponsavelOptions
        : this.usuarioOptionsSemTodos;
    },
    agendaDrawerTitle() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? "Agendar treinamento"
        : "Criar agendamento CRM";
    },
    agendaResponsavelLabel() {
      return this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
        ? "Responsável pelo treinamento"
        : "Responsável";
    },
    agendaHorariosContextoLabel() {
      const responsavel =
        this.optionText(
          this.agendaResponsavelOptions,
          this.agendaForm.id_usuario
        ) || "responsável não selecionado";
      const data = this.dateFromDateTimeLocal(this.agendaForm.data_inicio);
      const dataLabel = data
        ? new Date(`${data}T00:00:00`).toLocaleDateString("pt-BR")
        : "data não informada";

      return `${responsavel} em ${dataLabel}`;
    },
    fonteOptions() {
      return [{ value: null, text: "Sem fonte" }].concat(
        this.fontes.map((fonte) => ({
          value: fonte.id_crm_fonte,
          text: fonte.nome,
        }))
      );
    },
    fonteFiltroOptions() {
      return [{ value: null, text: "Todas" }].concat(
        this.fontes.map((fonte) => ({
          value: fonte.id_crm_fonte,
          text: fonte.nome,
        }))
      );
    },
    temperaturaFiltroOptions() {
      return [
        { value: "Todos", text: "Todas" },
        { value: "__sem_temperatura__", text: "Sem temperatura" },
      ].concat(
        this.temperaturaOptions.filter((option) => option.value !== null)
      );
    },
    motivoPerdaOptions() {
      return [{ value: null, text: "Selecione" }].concat(
        this.motivosPerda.map((motivo) => ({
          value: motivo.id_crm_motivo_perda,
          text: motivo.nome,
        }))
      );
    },
    agendaSlots() {
      return this.agendaHorarios ? this.agendaHorarios.slots || [] : [];
    },
    tipoTarefaOptions() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [
            { nome: "Tarefa", chave: "tarefa" },
            { nome: "Ligação", chave: "ligacao" },
            { nome: "Reunião", chave: "reuniao" },
            { nome: "Nota", chave: "nota" },
            { nome: "Follow-up", chave: "follow_up" },
          ];

      return tipos.map((tipo) => ({
        value: tipo.chave,
        text: tipo.nome,
      }));
    },
    agendaClienteLabel() {
      return (
        this.oportunidadeSelecionada.pessoa ||
        this.oportunidadeSelecionada.contato ||
        "Sem cliente/contato informado"
      );
    },
    cidadeFechamentoLabel() {
      return [this.ganho.cidade, this.ganho.uf].filter(Boolean).join(" / ");
    },
    activeFilters() {
      return [
        {
          key: "id_usuario",
          label: "Responsável",
          value: this.optionText(
            this.usuarioOptionsSemTodos,
            this.filtros.id_usuario
          ),
        },
        {
          key: "status",
          label: "Status",
          value:
            this.filtros.status && this.filtros.status !== "aberta"
              ? this.optionText(this.statusOptions, this.filtros.status)
              : null,
        },
        {
          key: "id_crm_fonte",
          label: "Fonte",
          value: this.filtros.id_crm_fonte
            ? this.optionText(this.fonteOptions, this.filtros.id_crm_fonte)
            : null,
        },
        {
          key: "periodo_atividade",
          label: "Próxima tarefa",
          value:
            this.filtros.periodo_atividade &&
            this.filtros.periodo_atividade !== "Todos"
              ? this.optionText(
                  this.periodoAtividadeOptions,
                  this.filtros.periodo_atividade
                )
              : null,
        },
        {
          key: "temperatura",
          label: "Temperatura",
          value:
            this.filtros.temperatura && this.filtros.temperatura !== "Todos"
              ? this.optionText(
                  this.temperaturaFiltroOptions,
                  this.filtros.temperatura
                )
              : null,
        },
        { key: "busca", label: "Busca", value: this.filtros.busca },
        {
          key: "busca_notas",
          label: "Notas",
          value: this.filtros.busca_notas,
        },
        {
          key: "data_inicio",
          label: "Data inicial",
          value: this.filtros.data_inicio,
        },
        { key: "data_fim", label: "Data final", value: this.filtros.data_fim },
      ];
    },
    activeFilterCount() {
      return this.activeFilters.filter((filter) => !!filter.value).length;
    },
    etapaDestinoSelecionada() {
      return this.findEtapaById(this.idEtapaDestino);
    },
    camposObrigatoriosMovimento() {
      return this.camposObrigatoriosEtapa(this.etapaDestinoSelecionada);
    },
    movimentoExigeValorNegociacao() {
      return this.camposObrigatoriosMovimento.some(
        (regra) => this.campoObrigatorioChave(regra) === "valor_negociacao"
      );
    },
    movimentoExigeAtribuicao() {
      const origem = this.findEtapaById(
        this.oportunidadeSelecionada.id_crm_etapa
      );
      const destino = this.findEtapaById(this.idEtapaDestino);

      return (
        !this.oportunidadeTemVendedorResponsavel(
          this.oportunidadeSelecionada
        ) &&
        this.etapaPossuiChave(origem, "primeiro_contato") &&
        this.etapaPossuiChave(destino, "qualificacao")
      );
    },
    usuarioDestinoSemAcesso() {
      if (!this.movimentoExigeAtribuicao || !this.idUsuarioDestino) {
        return false;
      }

      if (this.usuarioTemAcessoPorPapelAoFunilAtual(this.idUsuarioDestino)) {
        return false;
      }

      const ids = this.funilAtualUsuariosAcesso;
      return ids.length > 0 && !ids.includes(Number(this.idUsuarioDestino));
    },
    funilAtualUsuariosAcesso() {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null);
      const acessos =
        funil && funil.usuarios_acesso ? funil.usuarios_acesso : [];

      return acessos
        .filter((acesso) => acesso.ativo !== false)
        .map((acesso) => Number(acesso.id_usuario));
    },
    movimentoExigeTecnico() {
      return (
        !this.oportunidadeTemResponsavelTecnico(this.oportunidadeSelecionada) &&
        this.isEtapaApresentacaoTecnica(this.etapaDestinoSelecionada)
      );
    },
    vinculoSelecionadoLabel() {
      return this.vinculoSelecionado
        ? this.vinculoSelecionado.label
        : "Nenhum contato selecionado";
    },
    wizardFunilEtapaLabel() {
      const funil = this.optionText(
        this.funilOptionsSemTodos,
        this.form.id_crm_funil
      );
      const etapa = this.etapaInicialLabel(this.form.id_crm_funil);

      return [funil, etapa].filter(Boolean).join(" · ");
    },
    wizardPreviewOportunidade() {
      return {
        id_crm_oportunidade: "preview",
        titulo: this.form.titulo || "Nova oportunidade",
        contato: this.vinculoSelecionadoLabel,
        pessoa: null,
        fonte: this.optionText(this.fonteOptions, this.form.id_crm_fonte),
        campanha: this.form.campanha,
        usuario: this.optionText(
          this.usuarioOptionsSemTodos,
          this.form.id_usuario
        ),
        valor_estimado: this.form.valor_estimado || 0,
        status: "aberta",
        temperatura: this.form.temperatura,
        proxima_atividade_em: this.form.proxima_atividade_em,
      };
    },
    wizardOrigemLabel() {
      const fonte = this.optionText(this.fonteOptions, this.form.id_crm_fonte);
      const campanha = this.form.campanha;

      return (
        [fonte && fonte !== "Sem fonte" ? fonte : null, campanha]
          .filter(Boolean)
          .join(" · ") || "Não informada"
      );
    },
  },
  mounted() {
    this.loadBase();
    window.addEventListener("resize", this.atualizarKanbanScrollWidth);
  },
  beforeDestroy() {
    clearTimeout(this.buscaTimer);
    window.removeEventListener("resize", this.atualizarKanbanScrollWidth);
  },
  watch: {
    "agendaForm.id_usuario": "resetAgendaHorarios",
    "agendaForm.data_inicio": "resetAgendaHorarios",
    "agendaForm.duracao_minutos": "resetAgendaHorarios",
  },
  methods: {
    filtrosPadrao() {
      return {
        id_crm_funil: null,
        id_usuario: null,
        id_crm_fonte: null,
        status: "aberta",
        busca: "",
        busca_notas: "",
        temperatura: "Todos",
        periodo_atividade: "Todos",
        data_inicio: null,
        data_fim: null,
      };
    },
    emptyForm() {
      return {
        id_crm_oportunidade: null,
        titulo: "",
        id_crm_funil: null,
        id_crm_etapa: null,
        id_usuario: null,
        id_crm_fonte: null,
        campanha: "",
        valor_estimado: 0,
        previsao_fechamento: null,
        proxima_atividade_em: null,
        temperatura: null,
      };
    },
    emptyTarefaForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        id_usuario: null,
        vencimento_em: this.toDateTimeLocal(new Date()),
        descricao: "",
        concluir_ao_criar: false,
      };
    },
    emptyAgendaForm() {
      return {
        id_crm_atividade: null,
        titulo: "",
        tipo: "follow_up",
        id_usuario: null,
        data_inicio: this.toDateTimeLocal(new Date()),
        duracao_minutos: 30,
        descricao: "",
      };
    },
    emptyNotaForm() {
      return {
        descricao: "",
      };
    },
    emptyPerda() {
      return {
        id_crm_oportunidade: null,
        id_crm_motivo_perda: null,
        motivo_perda_observacao: "",
      };
    },
    emptyGanho() {
      return {
        id_crm_oportunidade: null,
        titulo: "",
        cliente: "",
        nome_correto: "",
        cnpj: "",
        email_cliente: "",
        telefone_cliente: "",
        endereco_cliente: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        complemento: "",
        id_cidade: null,
        cidade: "",
        uf: "",
        valor_final: 0,
        beneficios: "",
        beneficios_livres: "",
        beneficios_estruturados: [],
        cliente_final: false,
      };
    },
    emptyDadosNegociacao() {
      return {
        cliente: "",
        origem: "",
        valor: 0,
        telefone: "",
        email: "",
        beneficios: "",
      };
    },
    emptyDragState() {
      return {
        oportunidade: null,
        origemId: null,
        destinoId: null,
        moving: false,
      };
    },
    async loadBase() {
      const [
        funis,
        motivos,
        usuarios,
        tiposTarefa,
        temperaturas,
        fontes,
        vendedoresAtribuicao,
        desenvolvedoresAtribuicao,
        treinamentoAtribuicao,
      ] = await Promise.all([
        crmService.funis(),
        crmService.motivosPerda(),
        crmService.usuarios({
          per_page: 100,
          page: 1,
          sort: [{ field: "nome", type: "asc" }],
        }),
        crmService.tiposTarefaConfiguracao(),
        crmService.temperaturasConfiguracao(),
        crmService.fontes(),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "vendedor" }),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "desenvolvedor" }),
        crmService.usuariosAtribuicoesConfiguracao({ papel: "treinamento" }),
      ]);
      this.funis = this.normalizeCollection(funis.data);
      this.motivosPerda = this.normalizeCollection(motivos.data);
      this.usuarios = this.normalizeCollection(usuarios.data);
      this.tiposTarefa = this.normalizeCollection(tiposTarefa.data);
      this.temperaturaOptions = this.temperaturaOptionsFromList(
        this.normalizeCollection(temperaturas.data)
      );
      this.fontes = this.normalizeCollection(fontes.data);
      this.vendedoresAtribuicao =
        this.vendedoresFromAtribuicoes(vendedoresAtribuicao);
      this.desenvolvedoresAtribuicao = this.desenvolvedoresFromAtribuicoes(
        desenvolvedoresAtribuicao
      );
      this.treinamentoAtribuicao = this.usuariosPorPapelFromAtribuicoes(
        treinamentoAtribuicao,
        "treinamento"
      );
      this.restaurarUltimoFunilSelecionado();
      this.loadKanban();
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    temperaturaOptionsFromList(temperaturas) {
      const ativos = temperaturas.filter((item) => item.ativo !== false);

      if (!ativos.length) {
        return this.temperaturaOptions;
      }

      return [{ value: null, text: "Sem temperatura" }].concat(
        ativos.map((item) => ({
          value: item.chave,
          text: item.nome,
          cor: item.cor,
        }))
      );
    },
    etapaAutomacaoResumo(etapa) {
      const partes = [];

      if (etapa.sugerir_tarefa) {
        partes.push("sugere tarefa");
      }

      if (etapa.destacar_sem_tarefa) {
        partes.push("sem tarefa");
      }

      if (etapa.alertar_oportunidade_parada) {
        partes.push(`${etapa.alerta_parada_dias || 7}d parada`);
      }

      return partes.join(" · ");
    },
    buildKanbanParams(extra = {}) {
      return {
        ...this.filtros,
        modo: "leve",
        limit: KANBAN_LIMIT,
        ...extra,
      };
    },
    async loadKanban() {
      this.loading = true;
      this.kanbanError = "";
      try {
        const params = this.buildKanbanParams();
        const { data } = await crmService.kanban(params);
        this.kanban = data;
        const idFunilCarregado =
          data && data.funil
            ? data.funil.id_crm_funil
            : this.filtros.id_crm_funil;
        this.gravarUltimoFunilSelecionado(idFunilCarregado);
        this.$nextTick(this.atualizarKanbanScrollWidth);
      } catch (error) {
        this.kanban = null;
        this.kanbanError = this.apiError(
          error,
          "Você não tem permissão para acessar este funil CRM."
        );
        this.$toast.error(this.kanbanError);
      } finally {
        this.loading = false;
      }
    },
    debouncedLoadKanban() {
      clearTimeout(this.buscaTimer);
      this.buscaTimer = setTimeout(() => this.loadKanban(), 450);
    },
    limparBuscaRapida() {
      this.filtros.busca = "";
      this.debouncedLoadKanban();
    },
    limparFiltros() {
      const idFunilAtual = this.funilAtualId;
      this.filtros = {
        ...this.filtrosPadrao(),
        id_crm_funil: idFunilAtual,
      };
      this.filtersDrawerVisible = false;
      this.gravarUltimoFunilSelecionado(idFunilAtual);
      this.loadKanban();
    },
    aplicarFiltros() {
      this.filtersDrawerVisible = false;
      this.gravarUltimoFunilSelecionado(this.filtros.id_crm_funil);
      this.loadKanban();
    },
    limparFiltroAtivo(key) {
      if (key === "status") {
        this.filtros.status = "aberta";
      } else if (key === "periodo_atividade") {
        this.filtros.periodo_atividade = "Todos";
      } else if (key === "temperatura") {
        this.filtros.temperatura = "Todos";
      } else if (key === "busca") {
        this.filtros.busca = "";
      } else if (key === "busca_notas") {
        this.filtros.busca_notas = "";
      } else {
        this.filtros[key] = null;
      }

      this.loadKanban();
    },
    selecionarFunilRapido(idFunil) {
      if (Number(this.funilAtualId) === Number(idFunil)) {
        return;
      }

      this.filtros.id_crm_funil = idFunil;
      this.gravarUltimoFunilSelecionado(idFunil);
      this.loadKanban();
    },
    restaurarUltimoFunilSelecionado() {
      const idFunil = this.lerUltimoFunilSelecionado();

      if (!idFunil) {
        return;
      }

      const existe = this.funis.some(
        (funil) => Number(funil.id_crm_funil) === Number(idFunil)
      );

      if (existe) {
        this.filtros.id_crm_funil = Number(idFunil);
      }
    },
    lerUltimoFunilSelecionado() {
      try {
        return window.localStorage.getItem(LAST_FUNNEL_STORAGE_KEY);
      } catch (error) {
        return null;
      }
    },
    gravarUltimoFunilSelecionado(idFunil) {
      if (!idFunil) {
        return;
      }

      try {
        window.localStorage.setItem(LAST_FUNNEL_STORAGE_KEY, String(idFunil));
      } catch (error) {
        // Sem armazenamento local disponível, o funil segue funcionando normalmente.
      }
    },
    atualizarKanbanScrollWidth() {
      const kanban = this.$refs.kanbanScroll;

      if (!kanban) {
        this.kanbanScrollWidth = 0;
        return;
      }

      this.kanbanScrollWidth = kanban.scrollWidth;
    },
    sincronizarKanbanScroll(origem) {
      if (this.kanbanScrollSyncing) {
        return;
      }

      const topScroll = this.$refs.kanbanTopScroll;
      const bottomScroll = this.$refs.kanbanScroll;

      if (!topScroll || !bottomScroll) {
        return;
      }

      const origemScroll = origem === "top" ? topScroll : bottomScroll;
      const destinoScroll = origem === "top" ? bottomScroll : topScroll;

      this.kanbanScrollSyncing = true;
      destinoScroll.scrollLeft = origemScroll.scrollLeft;
      window.requestAnimationFrame(() => {
        this.kanbanScrollSyncing = false;
      });
    },
    optionText(options, value) {
      const option = options.find((item) => item.value === value);
      return option ? option.text : null;
    },
    etapaOptions(idFunil) {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) || (this.kanban ? this.kanban.funil : null);
      const etapas = funil && funil.etapas ? funil.etapas : [];
      return [{ value: null, text: "Primeira etapa" }].concat(
        etapas.map((etapa) => ({
          value: etapa.id_crm_etapa,
          text: etapa.nome,
        }))
      );
    },
    etapaInicialLabel(idFunil) {
      const kanbanFunil = this.kanban ? this.kanban.funil : null;
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) ||
        (kanbanFunil && Number(kanbanFunil.id_crm_funil) === Number(idFunil)
          ? kanbanFunil
          : null);
      const etapas = funil && Array.isArray(funil.etapas) ? funil.etapas : [];
      const [primeira] = etapas
        .filter((etapa) => etapa.ativo !== false)
        .sort(
          (a, b) =>
            Number(a.ordem || 0) - Number(b.ordem || 0) ||
            String(a.nome || "").localeCompare(String(b.nome || ""))
        );

      return primeira ? primeira.nome : "Primeira etapa ativa";
    },
    findEtapaById(idEtapa) {
      if (!idEtapa) {
        return null;
      }

      if (this.kanban && Array.isArray(this.kanban.colunas)) {
        const coluna = this.kanban.colunas.find(
          (item) => item.etapa.id_crm_etapa === Number(idEtapa)
        );

        if (coluna) {
          return coluna.etapa;
        }
      }

      for (const funil of this.funis) {
        const etapas = funil.etapas || [];
        const etapa = etapas.find(
          (item) => item.id_crm_etapa === Number(idEtapa)
        );

        if (etapa) {
          return etapa;
        }
      }

      return null;
    },
    camposObrigatoriosEtapa(etapa, contexto = "entrada_etapa") {
      if (!etapa) {
        return [];
      }

      return (
        etapa.campos_obrigatorios ||
        etapa.camposObrigatorios ||
        []
      ).filter(
        (regra) =>
          regra.ativo !== false &&
          (!regra.contexto || regra.contexto === contexto)
      );
    },
    isEtapaApresentacaoTecnica(etapa) {
      if (!etapa) {
        return false;
      }

      return (
        etapa.chave_preset === "apresentacao_tecnica" ||
        this.slugEtapa(etapa.nome) === "apresentacao_tecnica"
      );
    },
    etapaPossuiChave(etapa, chave) {
      if (!etapa) {
        return false;
      }

      const chaves = [etapa.chave_preset, etapa.chave, etapa.nome].map(
        (valor) => this.slugEtapa(valor)
      );

      return chaves.includes(chave);
    },
    oportunidadeTemVendedorResponsavel(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_vendedor_responsavel ||
          this.valorCampoComercial(oportunidade, "id_vendedor_responsavel"))
      );
    },
    oportunidadeTemResponsavelTecnico(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_responsavel_tecnico ||
          this.valorCampoComercial(oportunidade, "id_responsavel_tecnico"))
      );
    },
    slugEtapa(nome) {
      return String(nome || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_|_$/g, "");
    },
    deveAbrirModalMovimento(
      etapa,
      oportunidade = this.oportunidadeSelecionada
    ) {
      return (
        this.camposObrigatoriosEtapa(etapa).length > 0 ||
        (!this.oportunidadeTemResponsavelTecnico(oportunidade) &&
          this.isEtapaApresentacaoTecnica(etapa))
      );
    },
    campoObrigatorioConfig(regra) {
      return regra.campo || regra.campo_comercial || {};
    },
    campoObrigatorioChave(regra) {
      return this.campoObrigatorioConfig(regra).chave || regra.chave || "";
    },
    campoObrigatorioTipo(regra) {
      return this.campoObrigatorioConfig(regra).tipo || regra.tipo || "texto";
    },
    isCampoObrigatorioMonetario(regra) {
      return [
        "valor_estimado",
        "valor_proposta",
        "valor_negociacao",
        "valor_final",
      ].includes(this.campoObrigatorioChave(regra));
    },
    labelCampoObrigatorio(regra) {
      return this.campoObrigatorioConfig(regra).nome || regra.nome || "Campo";
    },
    campoObrigatorioOptions(regra) {
      const opcoes = this.campoObrigatorioConfig(regra).opcoes || [];
      const valores = Array.isArray(opcoes)
        ? opcoes
        : this.parseCampoObrigatorioOpcoes(opcoes);

      return [{ value: null, text: "Selecione" }].concat(
        valores.map((valor) =>
          typeof valor === "object"
            ? {
                value: valor.value || valor.valor || valor.label,
                text: valor.label || valor.text || valor.valor,
              }
            : { value: valor, text: valor }
        )
      );
    },
    parseCampoObrigatorioOpcoes(opcoes) {
      const texto = String(opcoes || "");

      if (!texto) {
        return [];
      }

      try {
        const parsed = JSON.parse(texto);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (error) {
        // Campo legado pode vir como texto livre separado por linha.
      }

      return texto.split("\n").filter(Boolean);
    },
    prepararCamposMovimento() {
      const form = {};

      this.camposObrigatoriosMovimento.forEach((regra) => {
        const idCampo = regra.id_crm_campo_comercial;
        let valor = this.movimentoCamposForm[idCampo] || "";

        if (
          this.movimentoManterValor &&
          this.campoObrigatorioChave(regra) === "valor_negociacao"
        ) {
          valor = this.valorPadraoNegociacao();
        }

        this.$set(form, idCampo, valor);
      });

      this.movimentoCamposForm = form;
    },
    valorPadraoNegociacao() {
      const valor =
        this.valorCampoComercial(
          this.oportunidadeSelecionada,
          "valor_proposta"
        ) || this.valorPrincipalOportunidade(this.oportunidadeSelecionada);

      return valor ? valor.toFixed(2) : "";
    },
    validarCamposMovimento() {
      if (this.movimentoExigeAtribuicao && !this.idUsuarioDestino) {
        this.$toast.error(
          "Selecione o vendedor responsável pela oportunidade."
        );
        return false;
      }

      if (this.movimentoExigeTecnico && !this.idUsuarioTecnicoDestino) {
        this.$toast.error(
          "Selecione o desenvolvedor responsável pela apresentação técnica."
        );
        return false;
      }

      if (this.usuarioDestinoSemAcesso && !this.concederAcessoFunilDestino) {
        this.$toast.error(
          "O usuário escolhido ainda não tem acesso ao funil atual."
        );
        return false;
      }

      const faltante = this.camposObrigatoriosMovimento.find((regra) => {
        const valor =
          this.movimentoCamposForm[regra.id_crm_campo_comercial] || "";
        return String(valor).trim() === "";
      });

      if (faltante) {
        this.$toast.error(
          faltante.mensagem ||
            `Preencha o campo obrigatório: ${this.labelCampoObrigatorio(
              faltante
            )}.`
        );
        return false;
      }

      return true;
    },
    movimentoCamposPayload() {
      return this.camposObrigatoriosMovimento.map((regra) => ({
        id_crm_campo_comercial: regra.id_crm_campo_comercial,
        valor: this.movimentoCamposForm[regra.id_crm_campo_comercial],
      }));
    },
    abrirModalMoverComDestino(oportunidade, idEtapaDestino) {
      this.oportunidadeSelecionada = oportunidade;
      this.idEtapaDestino = idEtapaDestino;
      this.idUsuarioTecnicoDestino = null;
      this.idUsuarioDestino = null;
      this.concederAcessoFunilDestino = false;
      this.movimentoCamposForm = {};
      this.movimentoManterValor = true;
      this.prepararCamposMovimento();
      this.$bvModal.show("crm-mover-oportunidade-modal");
    },
    abrirModalCriacao() {
      this.form = this.emptyForm();
      this.form.id_crm_funil =
        this.filtros.id_crm_funil ||
        (this.kanban ? this.kanban.funil.id_crm_funil : null);
      this.form.id_crm_etapa = null;
      this.vinculoSelecionado = null;
      this.wizardStep = 0;
      this.$bvModal.show("crm-funil-oportunidade-modal");
    },
    abrirModalEdicao(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.form = {
        id_crm_oportunidade: oportunidade.id_crm_oportunidade,
        titulo: oportunidade.titulo,
        id_crm_funil: oportunidade.id_crm_funil,
        id_crm_etapa: oportunidade.id_crm_etapa,
        id_usuario: oportunidade.id_usuario,
        id_crm_fonte: oportunidade.id_crm_fonte || null,
        campanha: oportunidade.campanha || "",
        valor_estimado:
          oportunidade.valor_estimado ||
          this.valorPrincipalOportunidade(oportunidade),
        previsao_fechamento: oportunidade.previsao_fechamento,
        temperatura: oportunidade.temperatura || null,
        proxima_atividade_em: this.toDateTimeLocal(
          oportunidade.proxima_atividade_em
        ),
      };
      this.$bvModal.show("crm-funil-oportunidade-modal");
    },
    async salvarOportunidade(criarOutra = false) {
      const payload = {
        ...this.form,
        titulo: (this.form.titulo || "").trim(),
        campanha: this.form.campanha || null,
      };

      if (!payload.titulo) {
        this.$toast.error("Informe o título da oportunidade.");
        return;
      }

      if (!payload.id_crm_oportunidade) {
        if (!this.vinculoSelecionado) {
          this.$toast.error(
            "Informe um contato ou cliente para a oportunidade."
          );
          return;
        }
        if (!payload.id_crm_funil) {
          this.$toast.error("Selecione o funil da oportunidade.");
          return;
        }

        this.form.titulo = payload.titulo;
        delete payload.id_crm_etapa;
        payload.id_crm_contato = this.vinculoSelecionado.id_crm_contato;
        payload.id_pessoa = this.vinculoSelecionado.id_pessoa;
        this.savingOportunidade = true;

        try {
          const { data: oportunidadeCriada } =
            await crmService.criarOportunidade(payload);
          this.$toast.success("Oportunidade criada com sucesso.");

          if (criarOutra) {
            this.reiniciarWizardCriacao();
            this.loadKanban();
          } else {
            this.$bvModal.hide("crm-funil-oportunidade-modal");
            this.abrirOportunidadeCriada(oportunidadeCriada, "funil");
          }
        } finally {
          this.savingOportunidade = false;
        }
      } else {
        this.savingOportunidade = true;

        try {
          await crmService.atualizarOportunidade(payload);
          this.$toast.success("Oportunidade atualizada com sucesso.");
          this.$bvModal.hide("crm-funil-oportunidade-modal");
          this.loadKanban();
        } finally {
          this.savingOportunidade = false;
        }
      }
    },
    reiniciarWizardCriacao() {
      const idFunil = this.form.id_crm_funil;
      this.form = this.emptyForm();
      this.form.id_crm_funil = idFunil;
      this.vinculoSelecionado = null;
      this.wizardStep = 0;
    },
    abrirOportunidadeCriada(oportunidade, origem) {
      if (!oportunidade || !oportunidade.id_crm_oportunidade) {
        this.loadKanban();
        return;
      }

      this.$router
        .push({
          name: "crmOportunidadeDetalhe",
          params: { id: oportunidade.id_crm_oportunidade },
          query: { origem },
        })
        .catch(() => {});
    },
    fecharCriacaoMaisTarde() {
      this.$bvModal.hide("crm-funil-oportunidade-modal");
    },
    irParaWizardStep(index) {
      if (index <= this.wizardStep) {
        this.wizardStep = index;
        return;
      }

      while (this.wizardStep < index) {
        if (!this.validarWizardStep(this.wizardStep)) {
          return;
        }

        this.wizardStep += 1;
      }
    },
    avancarWizard() {
      if (!this.validarWizardStep(this.wizardStep)) {
        return;
      }

      this.wizardStep = Math.min(
        this.wizardStep + 1,
        this.wizardSteps.length - 1
      );
    },
    validarWizardStep(step) {
      if (step === 0 && !(this.form.titulo || "").trim()) {
        this.$toast.error("Informe o nome da negociação.");
        return false;
      }

      if (step === 1 && !this.vinculoSelecionado) {
        this.$toast.error("Selecione ou crie um contato com WhatsApp.");
        return false;
      }

      if (step === 2 && !this.form.id_crm_funil) {
        this.$toast.error("Selecione o funil da oportunidade.");
        return false;
      }

      return true;
    },
    async criarContatoRapido(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.vinculoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    abrirDetalhe(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.$router.push({
        name: "crmOportunidadeDetalhe",
        params: { id: oportunidade.id_crm_oportunidade },
        query: { origem: "funil" },
      });
    },
    abrirModalMover(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.oportunidadeSelecionada = oportunidade;
      this.idEtapaDestino = oportunidade.id_crm_etapa;
      this.idUsuarioTecnicoDestino = null;
      this.idUsuarioDestino = null;
      this.concederAcessoFunilDestino = false;
      this.movimentoCamposForm = {};
      this.movimentoManterValor = true;
      this.prepararCamposMovimento();
      this.$bvModal.show("crm-mover-oportunidade-modal");
    },
    abrirModalAcoes(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.$bvModal.show("crm-funil-acoes-modal");
    },
    abrirModalTemperatura(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.temperaturaForm = {
        temperatura: oportunidade.temperatura || null,
      };
      this.$bvModal.show("crm-funil-temperatura-modal");
    },
    async salvarTemperaturaOportunidade() {
      if (!this.oportunidadeSelecionada.id_crm_oportunidade) {
        return;
      }

      try {
        await crmService.atualizarOportunidade({
          id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
          temperatura: this.temperaturaForm.temperatura || null,
        });
        this.atualizarTemperaturaVisual(
          this.oportunidadeSelecionada.id_crm_oportunidade,
          this.temperaturaForm.temperatura || null
        );
        this.$toast.success("Temperatura atualizada.");
        this.$bvModal.hide("crm-funil-temperatura-modal");
        this.loadKanban();
      } catch (error) {
        this.$toast.error(
          this.apiError(error, "Não foi possível atualizar a temperatura.")
        );
      }
    },
    atualizarTemperaturaVisual(idOportunidade, temperatura) {
      if (!this.kanban || !Array.isArray(this.kanban.colunas)) {
        return;
      }

      this.kanban.colunas.forEach((coluna) => {
        coluna.oportunidades.forEach((oportunidade) => {
          if (
            Number(oportunidade.id_crm_oportunidade) === Number(idOportunidade)
          ) {
            this.$set(oportunidade, "temperatura", temperatura);
          }
        });
      });

      if (
        this.oportunidadeSelecionada &&
        Number(this.oportunidadeSelecionada.id_crm_oportunidade) ===
          Number(idOportunidade)
      ) {
        this.oportunidadeSelecionada = {
          ...this.oportunidadeSelecionada,
          temperatura,
        };
      }
    },
    temperaturaIcon(valor) {
      const icons = {
        muito_frio: "la la-thermometer-empty",
        frio: "la la-thermometer-quarter",
        morno: "la la-thermometer-half",
        quente: "la la-thermometer-three-quarters",
        venda_certa: "la la-thermometer-full",
      };

      return icons[valor] || "la la-thermometer-empty";
    },
    temperaturaColor(valor) {
      const option = this.temperaturaOptions.find(
        (item) => item.value === valor
      );

      return option && option.cor ? option.cor : "#7e8299";
    },
    isContrato(oportunidade) {
      return oportunidade && oportunidade.tipo_fluxo === "contratos";
    },
    isVendaClienteFinal(oportunidade) {
      if (oportunidade && oportunidade.tipo_fluxo === "vendas_cliente_final") {
        return true;
      }

      const idFunil = oportunidade ? oportunidade.id_crm_funil : null;
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(idFunil)
        ) ||
        (this.kanban &&
        this.kanban.funil &&
        Number(this.kanban.funil.id_crm_funil) === Number(idFunil)
          ? this.kanban.funil
          : null);

      return funil && funil.chave_preset === "vendas_cliente_final";
    },
    clienteContrato(oportunidade) {
      return (
        oportunidade.pessoa || oportunidade.contato || "Cliente não informado"
      );
    },
    telefoneContrato(oportunidade) {
      return (
        oportunidade.contato_telefone ||
        oportunidade.telefone_contato ||
        oportunidade.pessoa_telefone ||
        ""
      );
    },
    emailContrato(oportunidade) {
      return oportunidade.contato_email || oportunidade.pessoa_email || "";
    },
    beneficiosOportunidade(oportunidade) {
      const estruturados = this.beneficiosEstruturadosOportunidade(oportunidade)
        .map((item) => this.beneficioLabel(item))
        .filter(Boolean)
        .join(", ");
      const livres = this.beneficiosLivresOportunidade(oportunidade);

      return [estruturados, livres].filter(Boolean).join(" | ");
    },
    beneficiosLivresOportunidade(oportunidade) {
      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campoLivres = campos.find(
        (item) => item.chave === "beneficios_livres"
      );
      const campoLegado = campos.find((item) => item.chave === "beneficios");
      return String(
        oportunidade.beneficios_livres ||
          oportunidade.beneficios ||
          (campoLivres ? campoLivres.valor : "") ||
          (campoLegado ? campoLegado.valor : "") ||
          ""
      ).trim();
    },
    beneficiosEstruturadosOportunidade(oportunidade) {
      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campoEstruturado = campos.find(
        (item) => item.chave === "beneficios_estruturados"
      );
      const valorEstruturado =
        oportunidade.beneficios_estruturados ||
        (campoEstruturado ? campoEstruturado.valor : "");
      const estruturados = this.beneficiosEstruturadosLista(valorEstruturado);

      if (estruturados.length || campoEstruturado) {
        return estruturados;
      }

      return this.beneficiosEstruturadosLista(
        oportunidade.beneficios ||
          this.beneficiosLivresOportunidade(oportunidade)
      );
    },
    abrirDadosNegociacao(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.dadosNegociacao = {
        cliente: this.clienteContrato(oportunidade),
        origem: oportunidade.oportunidade_origem || oportunidade.titulo || "-",
        valor: this.valorPrincipalOportunidade(oportunidade),
        telefone: this.telefoneContrato(oportunidade),
        email: this.emailContrato(oportunidade),
        beneficios: this.beneficiosOportunidade(oportunidade),
      };
      this.$bvModal.show("crm-dados-negociacao-modal");
    },
    enviarContratoWhatsapp(oportunidade) {
      const telefone = this.normalizarTelefoneWhatsapp(
        oportunidade.contato_telefone_normalizado ||
          this.telefoneContrato(oportunidade)
      );

      if (!telefone) {
        this.$toast.error("Telefone não informado para enviar o contrato.");
        return;
      }

      const mensagem = `Olá ${this.clienteContrato(
        oportunidade
      )}, segue o contrato referente à negociação ${oportunidade.titulo}.`;
      window.open(
        `https://web.whatsapp.com/send?phone=${telefone}&text=${encodeURIComponent(
          mensagem
        )}`,
        "_blank",
        "noopener"
      );
    },
    enviarContratoEmail(oportunidade) {
      const email = this.emailContrato(oportunidade);

      if (!email) {
        this.$toast.error("E-mail não informado para enviar o contrato.");
        return;
      }

      const assunto = `Contrato - ${this.clienteContrato(oportunidade)}`;
      const corpo = `Olá,\n\nSegue o contrato referente à negociação ${
        oportunidade.titulo
      }.\n\nValor negociado: ${this.formatMoney(
        this.valorPrincipalOportunidade(oportunidade)
      )}.\n`;
      window.location.href = `mailto:${email}?subject=${encodeURIComponent(
        assunto
      )}&body=${encodeURIComponent(corpo)}`;
    },
    normalizarTelefoneWhatsapp(value) {
      let telefone = String(value || "").replace(/\D+/g, "");

      if (!telefone) {
        return "";
      }

      if (!telefone.startsWith("55") && telefone.length <= 11) {
        telefone = `55${telefone}`;
      }

      return telefone;
    },
    abrirModalTarefa(oportunidade, sugestao = null) {
      this.oportunidadeSelecionada = oportunidade;
      this.tarefaForm = this.emptyTarefaForm();
      this.tarefaForm.id_usuario = oportunidade.id_usuario;
      this.tarefaForm.tipo =
        sugestao && sugestao.tipo
          ? sugestao.tipo
          : this.tipoTarefaOptions.length
          ? this.tipoTarefaOptions[0].value
          : "tarefa";
      this.tarefaForm.titulo =
        sugestao && sugestao.titulo
          ? sugestao.titulo
          : `Follow-up - ${oportunidade.titulo}`;

      if (sugestao && sugestao.prazo_horas !== null) {
        const vencimento = new Date();
        vencimento.setHours(
          vencimento.getHours() + Number(sugestao.prazo_horas || 0)
        );
        this.tarefaForm.vencimento_em = this.toDateTimeLocal(vencimento);
      }

      this.tarefaDrawerVisible = true;
    },
    async criarTarefa(agendar = false) {
      if (!this.tarefaForm.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      const response = await crmService.criarAtividade({
        ...this.tarefaForm,
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        vencimento_em: this.fromDateTimeLocal(this.tarefaForm.vencimento_em),
      });
      const atividade = this.responseData(response);
      this.$toast.success("Tarefa criada com sucesso.");
      this.tarefaDrawerVisible = false;

      if (agendar) {
        this.abrirModalAgenda(this.oportunidadeSelecionada, atividade);
      }

      this.loadKanban();
    },
    abrirModalAgenda(oportunidade, tarefa = null) {
      this.oportunidadeSelecionada = oportunidade;
      this.agendaForm = this.emptyAgendaForm();
      this.agendaForm.id_usuario = this.isTreinamentoClienteFinal(oportunidade)
        ? this.idPrimeiroResponsavelTreinamento()
        : oportunidade.id_usuario;
      this.agendaForm.titulo = this.isTreinamentoClienteFinal(oportunidade)
        ? `Treinamento - ${oportunidade.titulo}`
        : `Agenda - ${oportunidade.titulo}`;
      this.agendaForm.tipo = this.isTreinamentoClienteFinal(oportunidade)
        ? "treinamento_cliente_final"
        : this.agendaForm.tipo;
      this.agendaForm.descricao = this.isTreinamentoClienteFinal(oportunidade)
        ? "Agendamento criado a partir do funil Treinamento Cliente Final."
        : this.agendaForm.descricao;
      this.tarefaAgendamentoOrigem = tarefa;

      if (tarefa) {
        this.preencherAgendaPorTarefa(tarefa);
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
      this.agendaDrawerVisible = true;
    },
    preencherAgendaPorTarefa(tarefa) {
      const treinamentoClienteFinal = this.isTreinamentoClienteFinal(
        this.oportunidadeSelecionada
      );
      this.agendaForm.id_crm_atividade = tarefa.id_crm_atividade || null;
      this.agendaForm.titulo = treinamentoClienteFinal
        ? `Treinamento - ${this.oportunidadeSelecionada.titulo}`
        : `Tarefa - ${tarefa.titulo}`;
      this.agendaForm.id_usuario = treinamentoClienteFinal
        ? this.agendaForm.id_usuario ||
          this.idPrimeiroResponsavelTreinamento() ||
          tarefa.id_usuario ||
          this.oportunidadeSelecionada.id_usuario
        : tarefa.id_usuario || this.oportunidadeSelecionada.id_usuario;
      this.agendaForm.tipo = treinamentoClienteFinal
        ? "treinamento_cliente_final"
        : this.agendaForm.tipo;
      this.agendaForm.data_inicio = tarefa.vencimento_em
        ? this.toDateTimeLocal(tarefa.vencimento_em)
        : this.agendaForm.data_inicio;
      this.agendaForm.descricao = [
        `Tarefa: ${tarefa.titulo}`,
        `Tipo: ${this.tipoTarefaLabel(tarefa.tipo)}`,
        tarefa.descricao ? `Descrição: ${tarefa.descricao}` : null,
      ]
        .filter(Boolean)
        .join("\n");
    },
    async buscarHorariosAgenda() {
      if (!this.agendaForm.id_usuario) {
        this.$toast.error("Selecione o responsável.");
        return;
      }

      this.loadingAgendaHorarios = true;
      this.agendaHorariosErro = "";

      try {
        const { data } = await crmService.horariosDisponiveisAgenda({
          data: this.dateFromDateTimeLocal(this.agendaForm.data_inicio),
          id_usuario: this.agendaForm.id_usuario,
          id_crm_oportunidade: this.oportunidadeSelecionada
            ? this.oportunidadeSelecionada.id_crm_oportunidade
            : null,
          id_crm_atividade: this.agendaForm.id_crm_atividade,
          duracao_minutos: Number(this.agendaForm.duracao_minutos || 30),
        });
        this.agendaHorarios = data;
      } catch (error) {
        this.agendaHorarios = null;
        this.agendaHorariosErro = this.apiError(
          error,
          "Não foi possível buscar os horários."
        );
      } finally {
        this.loadingAgendaHorarios = false;
      }
    },
    resetAgendaHorarios() {
      if (!this.agendaDrawerVisible) {
        return;
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
    },
    selecionarHorarioAgenda(slot) {
      if (!slot.disponivel) {
        return;
      }

      this.agendaForm.data_inicio = this.toDateTimeLocal(slot.inicio);
    },
    agendaSlotSelecionado(slot) {
      return this.agendaForm.data_inicio === this.toDateTimeLocal(slot.inicio);
    },
    async criarAgenda() {
      if (!this.agendaForm.titulo || !this.agendaForm.data_inicio) {
        this.$toast.error("Informe o título e a data da agenda.");
        return;
      }

      await crmService.criarAgendamento({
        ...this.agendaForm,
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        id_crm_atividade: this.agendaForm.id_crm_atividade,
        observacoes: this.tarefaAgendamentoOrigem
          ? `Agendamento criado a partir da tarefa #${this.tarefaAgendamentoOrigem.id_crm_atividade}: ${this.tarefaAgendamentoOrigem.titulo}`
          : this.agendaForm.descricao,
        data_inicio: this.fromDateTimeLocal(this.agendaForm.data_inicio),
      });
      this.$toast.success(
        this.isTreinamentoClienteFinal(this.oportunidadeSelecionada)
          ? "Treinamento agendado e enviado ao funil Treinamento."
          : "Agendamento CRM criado com sucesso."
      );
      this.agendaDrawerVisible = false;
      this.tarefaAgendamentoOrigem = null;
      this.loadKanban();
    },
    abrirModalNota(oportunidade) {
      this.oportunidadeSelecionada = oportunidade;
      this.notaForm = this.emptyNotaForm();
      this.$bvModal.show("crm-funil-nota-modal");
    },
    async adicionarNota() {
      if (!this.notaForm.descricao) {
        this.$toast.error("Informe a nota.");
        return;
      }

      await crmService.adicionarNota({
        id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
        id_crm_contato: this.oportunidadeSelecionada.id_crm_contato,
        descricao: this.notaForm.descricao,
      });
      this.$toast.success("Nota adicionada com sucesso.");
      this.$bvModal.hide("crm-funil-nota-modal");
      this.loadKanban();
    },
    async moverOportunidade() {
      if (
        !this.idEtapaDestino ||
        this.idEtapaDestino === this.oportunidadeSelecionada.id_crm_etapa
      ) {
        this.$bvModal.hide("crm-mover-oportunidade-modal");
        return;
      }

      this.prepararCamposMovimento();

      if (!this.validarCamposMovimento()) {
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      const movimento = this.aplicarMovimentoVisual(
        this.oportunidadeSelecionada,
        this.idEtapaDestino
      );

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: this.oportunidadeSelecionada.id_crm_oportunidade,
          id_crm_etapa: this.idEtapaDestino,
          id_usuario_tecnico: this.movimentoExigeTecnico
            ? this.idUsuarioTecnicoDestino
            : null,
          id_usuario_destino: this.movimentoExigeAtribuicao
            ? this.idUsuarioDestino
            : null,
          id_vendedor_responsavel: this.movimentoExigeAtribuicao
            ? this.idUsuarioDestino
            : null,
          conceder_acesso_funil: this.concederAcessoFunilDestino,
          campos_comerciais: this.movimentoCamposPayload(),
        });
        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Oportunidade movida com sucesso.");
        this.$bvModal.hide("crm-mover-oportunidade-modal");
        this.sugerirTarefaDaEtapa(movimento.destino, movimento.oportunidade);
        this.loadKanban();
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível mover a oportunidade.")
        );
      }
    },
    async moverOportunidadeDoCard({ oportunidade, id_crm_etapa }) {
      if (!id_crm_etapa || id_crm_etapa === oportunidade.id_crm_etapa) {
        return;
      }

      const etapaDestino = this.findEtapaById(id_crm_etapa);

      if (this.deveAbrirModalMovimento(etapaDestino, oportunidade)) {
        this.abrirModalMoverComDestino(oportunidade, id_crm_etapa);
        return;
      }

      const etapaOrigem = this.findEtapaById(oportunidade.id_crm_etapa);
      if (
        !this.oportunidadeTemVendedorResponsavel(oportunidade) &&
        this.etapaPossuiChave(etapaOrigem, "primeiro_contato") &&
        this.etapaPossuiChave(etapaDestino, "qualificacao")
      ) {
        this.abrirModalMoverComDestino(oportunidade, id_crm_etapa);
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      const movimento = this.aplicarMovimentoVisual(oportunidade, id_crm_etapa);

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: oportunidade.id_crm_oportunidade,
          id_crm_etapa,
        });

        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Etapa alterada.");
        this.sugerirTarefaDaEtapa(movimento.destino, movimento.oportunidade);
        this.loadKanban();
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível alterar a etapa.")
        );
      }
    },
    aplicarMovimentoVisual(oportunidade, idEtapaDestino) {
      const origem = this.kanban.colunas.find(
        (coluna) => coluna.etapa.id_crm_etapa === oportunidade.id_crm_etapa
      );
      const destino = this.kanban.colunas.find(
        (coluna) => coluna.etapa.id_crm_etapa === idEtapaDestino
      );

      if (!origem || !destino) {
        return {
          origem: null,
          destino: null,
          oportunidade,
        };
      }

      origem.oportunidades = origem.oportunidades.filter(
        (item) => item.id_crm_oportunidade !== oportunidade.id_crm_oportunidade
      );
      origem.total = Math.max(Number(origem.total || 0) - 1, 0);
      const valorOportunidade = this.valorPrincipalOportunidade(oportunidade);
      origem.valor_total = Math.max(
        Number(origem.valor_total || 0) - valorOportunidade,
        0
      );

      const oportunidadeMovida = {
        ...oportunidade,
        id_crm_etapa: idEtapaDestino,
        etapa: destino.etapa.nome,
      };

      destino.oportunidades.unshift(oportunidadeMovida);
      destino.total = Number(destino.total || 0) + 1;
      destino.valor_total =
        Number(destino.valor_total || 0) + valorOportunidade;

      return {
        origem,
        destino,
        oportunidade: oportunidadeMovida,
      };
    },
    sugerirTarefaDaEtapa(destino, oportunidade) {
      const etapa = destino && destino.etapa ? destino.etapa : {};

      if (!etapa.sugerir_tarefa) {
        return;
      }

      this.abrirModalTarefa(oportunidade, {
        tipo: etapa.tarefa_sugerida_tipo || "tarefa",
        titulo:
          etapa.tarefa_sugerida_titulo || `Follow-up - ${oportunidade.titulo}`,
        prazo_horas:
          etapa.tarefa_sugerida_prazo_horas === null
            ? null
            : etapa.tarefa_sugerida_prazo_horas || 24,
      });
      this.$toast.warning("Tarefa sugerida pela etapa.");
    },
    iniciarDrag(oportunidade) {
      this.dragState = {
        oportunidade,
        origemId: oportunidade.id_crm_etapa,
        destinoId: null,
        moving: false,
      };
    },
    encerrarDrag() {
      if (this.dragState.moving) {
        return;
      }

      this.dragState = this.emptyDragState();
    },
    marcarColunaDrop(coluna) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      this.dragState.destinoId = coluna.etapa.id_crm_etapa;
    },
    limparColunaDrop(coluna, event) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      if (event.currentTarget.contains(event.relatedTarget)) {
        return;
      }

      if (this.dragState.destinoId === coluna.etapa.id_crm_etapa) {
        this.dragState.destinoId = null;
      }
    },
    colunaDropAtiva(coluna) {
      return (
        this.dragState.destinoId === coluna.etapa.id_crm_etapa &&
        this.dragState.origemId !== coluna.etapa.id_crm_etapa
      );
    },
    colunaDragOrigem(coluna) {
      return this.dragState.origemId === coluna.etapa.id_crm_etapa;
    },
    oportunidadeEmDrag(oportunidade) {
      return (
        this.dragState.oportunidade &&
        this.dragState.oportunidade.id_crm_oportunidade ===
          oportunidade.id_crm_oportunidade
      );
    },
    async soltarOportunidade(coluna) {
      if (!this.dragState.oportunidade || this.dragState.moving) {
        return;
      }

      const oportunidade = this.dragState.oportunidade;
      const idEtapaDestino = coluna.etapa.id_crm_etapa;

      if (idEtapaDestino === oportunidade.id_crm_etapa) {
        this.dragState = this.emptyDragState();
        return;
      }

      if (this.deveAbrirModalMovimento(coluna.etapa, oportunidade)) {
        this.dragState = this.emptyDragState();
        this.abrirModalMoverComDestino(oportunidade, idEtapaDestino);
        return;
      }

      const etapaOrigem = this.findEtapaById(oportunidade.id_crm_etapa);
      if (
        !this.oportunidadeTemVendedorResponsavel(oportunidade) &&
        this.etapaPossuiChave(etapaOrigem, "primeiro_contato") &&
        this.etapaPossuiChave(coluna.etapa, "qualificacao")
      ) {
        this.dragState = this.emptyDragState();
        this.abrirModalMoverComDestino(oportunidade, idEtapaDestino);
        return;
      }

      const snapshot = JSON.parse(JSON.stringify(this.kanban));
      this.dragState = {
        ...this.dragState,
        destinoId: idEtapaDestino,
        moving: true,
      };

      const movimento = this.aplicarMovimentoVisual(
        oportunidade,
        idEtapaDestino
      );

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: oportunidade.id_crm_oportunidade,
          id_crm_etapa: idEtapaDestino,
        });

        this.sincronizarOportunidadeSelecionada(movimento.oportunidade);
        this.$toast.success("Etapa alterada.");
      } catch (error) {
        this.kanban = snapshot;
        this.$toast.error(
          this.apiError(error, "Não foi possível alterar a etapa.")
        );
      } finally {
        this.dragState = this.emptyDragState();
      }
    },
    sincronizarOportunidadeSelecionada(oportunidade) {
      if (
        this.oportunidadeSelecionada &&
        this.oportunidadeSelecionada.id_crm_oportunidade ===
          oportunidade.id_crm_oportunidade
      ) {
        this.oportunidadeSelecionada = oportunidade;
      }
    },
    async carregarMais(coluna) {
      const idEtapa = coluna.etapa.id_crm_etapa;
      this.$set(this.loadingEtapas, idEtapa, true);

      try {
        const { data } = await crmService.kanban(
          this.buildKanbanParams({
            offsets: {
              [idEtapa]: coluna.oportunidades.length,
            },
          })
        );
        const novaColuna = data.colunas.find(
          (item) => item.etapa.id_crm_etapa === idEtapa
        );

        if (novaColuna) {
          coluna.oportunidades = coluna.oportunidades.concat(
            novaColuna.oportunidades
          );
          coluna.total = novaColuna.total;
          coluna.valor_total = novaColuna.valor_total;
        }
      } finally {
        this.$set(this.loadingEtapas, idEtapa, false);
      }
    },
    abrirModalGanho(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.oportunidadeSelecionada = oportunidade;
      const clienteFinal = this.isVendaClienteFinal(oportunidade);
      const enderecoPessoa = this.enderecoPessoaOportunidade(oportunidade);
      this.ganho = {
        ...this.emptyGanho(),
        id_crm_oportunidade: oportunidade.id_crm_oportunidade,
        titulo: oportunidade.titulo || "",
        cliente:
          oportunidade.pessoa ||
          oportunidade.contato ||
          "Cliente sem nome cadastrado",
        nome_correto:
          oportunidade.pessoa ||
          oportunidade.contato ||
          oportunidade.titulo ||
          "",
        cnpj:
          oportunidade.pessoa_cnpj_cpf || oportunidade.contato_documento || "",
        email_cliente: oportunidade.contato_email || "",
        telefone_cliente:
          oportunidade.contato_telefone ||
          oportunidade.telefone_contato ||
          oportunidade.pessoa_telefone ||
          "",
        endereco_cliente:
          this.valorCampoComercial(oportunidade, "endereco_cliente") ||
          this.enderecoFechamentoCompleto(enderecoPessoa),
        ...enderecoPessoa,
        valor_final: this.valorPrincipalOportunidade(oportunidade),
        beneficios: this.beneficiosLivresOportunidade(oportunidade),
        beneficios_livres: this.beneficiosLivresOportunidade(oportunidade),
        beneficios_estruturados: clienteFinal
          ? ["treinamento_cliente_final"]
          : this.beneficiosEstruturadosOportunidade(oportunidade),
        cliente_final: clienteFinal,
      };
      this.$bvModal.show("crm-ganhar-oportunidade-modal");
    },
    validarGanho() {
      this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(this.ganho);

      if (!(this.ganho.nome_correto || "").trim()) {
        this.$toast.error("Informe o nome correto do cliente.");
        return false;
      }

      if (this.somenteNumeros(this.ganho.cnpj).length !== 14) {
        this.$toast.error("Informe um CNPJ válido.");
        return false;
      }

      if (!(this.ganho.email_cliente || "").trim()) {
        this.$toast.error("Informe o e-mail do cliente.");
        return false;
      }

      if (!this.validarEnderecoGanho(this.ganho)) {
        return false;
      }

      if (Number(this.ganho.valor_final || 0) <= 0) {
        this.$toast.error("Informe o valor final.");
        return false;
      }

      if (
        !this.ganho.cliente_final &&
        !this.beneficiosEstruturadosLista(this.ganho.beneficios_estruturados)
          .length
      ) {
        this.$toast.error("Selecione pelo menos um benefício de regra.");
        return false;
      }

      return true;
    },
    async marcarGanha() {
      if (!this.validarGanho()) {
        return;
      }

      await crmService.marcarGanha({
        id_crm_oportunidade: this.ganho.id_crm_oportunidade,
        fechamento: {
          nome_correto: (this.ganho.nome_correto || "").trim(),
          cnpj: this.ganho.cnpj,
          email_cliente: (this.ganho.email_cliente || "").trim(),
          telefone_cliente: (this.ganho.telefone_cliente || "").trim(),
          endereco_cliente: (this.ganho.endereco_cliente || "").trim(),
          cep: this.ganho.cep,
          logradouro: this.ganho.logradouro,
          numero: this.ganho.numero,
          bairro: this.ganho.bairro,
          complemento: this.ganho.complemento,
          id_cidade: this.ganho.id_cidade,
          valor_final: Number(this.ganho.valor_final || 0),
          beneficios: (this.ganho.beneficios_livres || "").trim(),
          beneficios_livres: (this.ganho.beneficios_livres || "").trim(),
          beneficios_estruturados: this.ganho.cliente_final
            ? ["treinamento_cliente_final"]
            : this.beneficiosEstruturadosLista(
                this.ganho.beneficios_estruturados
              ),
        },
      });
      this.$toast.success("Oportunidade marcada como ganha.");
      this.$bvModal.hide("crm-ganhar-oportunidade-modal");
      this.loadKanban();
    },
    abrirModalPerda(oportunidade) {
      this.$bvModal.hide("crm-funil-acoes-modal");
      this.perda = this.emptyPerda();
      this.perda.id_crm_oportunidade = oportunidade.id_crm_oportunidade;
      this.$bvModal.show("crm-perder-oportunidade-modal");
    },
    async marcarPerdida() {
      if (!this.perda.id_crm_motivo_perda) {
        this.$toast.error("Informe o motivo da perda.");
        return;
      }

      await crmService.marcarPerdida(this.perda);
      this.$toast.success("Oportunidade marcada como perdida.");
      this.$bvModal.hide("crm-perder-oportunidade-modal");
      this.loadKanban();
    },
    proximaAcao(oportunidade) {
      if (!oportunidade.proxima_atividade_em) {
        return "Sem próxima ação";
      }

      return `Próxima ação: ${this.formatDateTime(
        oportunidade.proxima_atividade_em
      )}`;
    },
    oportunidadeAtrasada(oportunidade) {
      return (
        oportunidade.proxima_atividade_em &&
        new Date(oportunidade.proxima_atividade_em) < new Date()
      );
    },
    statusClass(status) {
      if (status === "ganha") {
        return "label-light-success";
      }

      if (status === "perdida") {
        return "label-light-danger";
      }

      return "label-light-primary";
    },
    statusLabel(status) {
      const labels = {
        aberta: "Aberta",
        ganha: "Ganha",
        perdida: "Perdida",
      };

      return labels[status] || status || "-";
    },
    tipoTarefaLabel(chave) {
      const tipo = this.tiposTarefa.find((item) => item.chave === chave);
      return tipo ? tipo.nome : chave || "-";
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    valorPrincipalOportunidade(oportunidade = {}) {
      const campos = [
        oportunidade.valor_principal,
        oportunidade.valor_final,
        oportunidade.valor_negociacao,
        oportunidade.valor_proposta,
        oportunidade.valor_estimado,
      ];
      const valor = campos.find(
        (item) => item !== null && item !== undefined && item !== ""
      );

      return Number(valor || 0);
    },
    valorCampoComercial(oportunidade = {}, chave) {
      if (oportunidade[chave] !== null && oportunidade[chave] !== undefined) {
        return Number(oportunidade[chave] || 0);
      }

      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campo = campos.find((item) => item.chave === chave);

      return campo && campo.valor !== "" && campo.valor !== null
        ? Number(campo.valor || 0)
        : 0;
    },
    beneficiosTexto(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return "";
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      return valores
        .map((item) => this.beneficioLabel(item))
        .filter(Boolean)
        .filter((item, index, array) => array.indexOf(item) === index)
        .filter((item, index, array) =>
          array.includes("Treinamento Cliente Final")
            ? item !== "Treinamento"
            : true
        )
        .join(", ");
    },
    beneficioLabel(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const labels = {
        website: "Website",
        web_site: "Website",
        site: "Website",
        treinamento: "Treinamento",
        treinamento_cliente_final: "Treinamento Cliente Final",
        treinamento_final: "Treinamento Cliente Final",
        cliente_final: "Treinamento Cliente Final",
        desconto: "Desconto",
        implantacao: "Implementação White Label",
        implementacao: "Implementação White Label",
        implantacao_white_label: "Implementação White Label",
        implementacao_white_label: "Implementação White Label",
        white_label: "Implementação White Label",
        suporte_estendido: "Suporte estendido",
      };

      return labels[key] || text.replace(/_/g, " ");
    },
    beneficioKey(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const keys = {
        website: "website",
        web_site: "website",
        site: "website",
        implantacao: "implementacao_white_label",
        implementacao: "implementacao_white_label",
        implantacao_white_label: "implementacao_white_label",
        implementacao_white_label: "implementacao_white_label",
        white_label: "implementacao_white_label",
        treinamento_cliente_final: "treinamento_cliente_final",
        treinamento_final: "treinamento_cliente_final",
        cliente_final: "treinamento_cliente_final",
      };

      return keys[key] || "";
    },
    beneficiosEstruturadosLista(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return [];
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      const permitidos = this.beneficioOptions.map((item) => item.value);
      return valores
        .map((item) => this.beneficioKey(item))
        .filter((item) => permitidos.includes(item))
        .filter((item, index, array) => array.indexOf(item) === index);
    },
    beneficioEstruturadoSelecionado(value) {
      return this.beneficiosEstruturadosLista(
        this.ganho.beneficios_estruturados
      ).includes(value);
    },
    toggleBeneficioGanho(value) {
      const key = this.beneficioKey(value);
      if (!key) {
        return;
      }

      let atuais = this.beneficiosEstruturadosLista(
        this.ganho.beneficios_estruturados
      );

      if (atuais.includes(key)) {
        this.ganho.beneficios_estruturados = atuais.filter(
          (item) => item !== key
        );
        return;
      }

      if (key === "treinamento_cliente_final") {
        this.ganho.beneficios_estruturados = [key];
        return;
      }

      atuais = atuais.filter((item) => item !== "treinamento_cliente_final");
      atuais.push(key);
      this.ganho.beneficios_estruturados = atuais;
    },
    adicionarBeneficioGanho(label) {
      this.toggleBeneficioGanho(label);
    },
    async consultarCnpjFechamento() {
      if (this.somenteNumeros(this.ganho.cnpj).length !== 14) {
        this.$toast.warning("Informe um CNPJ válido para consultar.");
        return;
      }

      this.loadingConsultaCnpjFechamento = true;

      try {
        const receita = await this.getConsultaReceita(this.ganho.cnpj);
        this.aplicarReceitaFechamento(receita);
        this.$toast.success(
          "Dados do CNPJ carregados. Confira antes de fechar."
        );
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CNPJ.")
        );
      } finally {
        this.loadingConsultaCnpjFechamento = false;
      }
    },
    aplicarReceitaFechamento(receita = {}) {
      this.ganho.nome_correto = receita.nome || this.ganho.nome_correto || "";

      if (receita.email && receita.email.email) {
        this.ganho.email_cliente = receita.email.email;
      }

      if (receita.telefone && receita.telefone.fone) {
        this.ganho.telefone_cliente = receita.telefone.fone;
      }

      if (receita.endereco && receita.endereco.cep) {
        this.ganho.cep = receita.endereco.cep || "";
        this.ganho.logradouro = receita.endereco.logradouro || "";
        this.ganho.numero = receita.endereco.numero || "";
        this.ganho.bairro = receita.endereco.bairro || "";
        this.ganho.complemento = receita.endereco.complemento || "";
        this.ganho.id_cidade = receita.endereco.id_cidade || null;
        this.ganho.cidade =
          receita.endereco.cidade && receita.endereco.cidade.cidade
            ? receita.endereco.cidade.cidade
            : "";
        this.ganho.uf =
          receita.endereco.cidade && receita.endereco.cidade.uf
            ? receita.endereco.cidade.uf
            : "";
        this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganho
        );
      }
    },
    async consultarCepFechamento() {
      if (this.somenteNumeros(this.ganho.cep).length !== 8) {
        this.$toast.warning("Informe um CEP válido para consultar.");
        return;
      }

      this.loadingConsultaCepFechamento = true;

      try {
        const cep = await this.getCep(this.ganho.cep);

        if (!cep || Array.isArray(cep) || cep.erro) {
          this.$toast.warning("Confira o CEP informado.");
          return;
        }

        this.ganho.logradouro = cep.logradouro || "";
        this.ganho.bairro = cep.bairro || "";
        this.ganho.complemento = cep.complemento || "";
        this.ganho.cep = cep.cep || this.ganho.cep;

        const cidade = await this.getCidadeByUF(cep.localidade, cep.uf);
        const cidadeSelecionada = this.primeiraCidadeConsulta(cidade);
        this.ganho.id_cidade = cidadeSelecionada
          ? cidadeSelecionada.id_cidade
          : null;
        this.ganho.cidade = cidadeSelecionada
          ? cidadeSelecionada.cidade
          : cep.localidade || "";
        this.ganho.uf = cidadeSelecionada ? cidadeSelecionada.uf : cep.uf || "";
        this.ganho.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganho
        );
        this.$toast.success("Endereço carregado pelo CEP.");
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CEP.")
        );
      } finally {
        this.loadingConsultaCepFechamento = false;
      }
    },
    primeiraCidadeConsulta(cidade) {
      return Array.isArray(cidade) ? cidade[0] : cidade;
    },
    enderecoPessoaOportunidade(oportunidade) {
      return {
        cep: oportunidade.pessoa_endereco_cep || "",
        logradouro: oportunidade.pessoa_endereco_logradouro || "",
        numero: oportunidade.pessoa_endereco_numero || "",
        bairro: oportunidade.pessoa_endereco_bairro || "",
        complemento: oportunidade.pessoa_endereco_complemento || "",
        id_cidade: oportunidade.pessoa_endereco_id_cidade || null,
        cidade: oportunidade.pessoa_endereco_cidade || "",
        uf: oportunidade.pessoa_endereco_uf || "",
      };
    },
    validarEnderecoGanho(form) {
      const enderecoTexto = (form.endereco_cliente || "").trim();
      const camposEstruturados = [
        form.cep,
        form.id_cidade,
        form.logradouro,
        form.numero,
        form.bairro,
      ];
      const temCampoEstruturado = camposEstruturados.some((valor) =>
        (valor || "").toString().trim()
      );

      if (!enderecoTexto && !temCampoEstruturado) {
        this.$toast.error("Informe o endereço do cliente.");
        return false;
      }

      if (!temCampoEstruturado && enderecoTexto) {
        return true;
      }

      if (this.somenteNumeros(form.cep).length !== 8) {
        this.$toast.error("Informe um CEP válido.");
        return false;
      }

      if (!form.id_cidade) {
        this.$toast.error("Informe a cidade do cliente pelo CEP.");
        return false;
      }

      if (!(form.logradouro || "").trim()) {
        this.$toast.error("Informe o logradouro do cliente.");
        return false;
      }

      if (!(form.numero || "").trim()) {
        this.$toast.error("Informe o número do endereço do cliente.");
        return false;
      }

      if (!(form.bairro || "").trim()) {
        this.$toast.error("Informe o bairro do cliente.");
        return false;
      }

      return true;
    },
    enderecoFechamentoCompleto(form) {
      const endereco = [
        form.logradouro,
        form.numero ? `nº ${form.numero}` : null,
        form.bairro,
        [form.cidade, form.uf].filter(Boolean).join(" / "),
        form.cep ? `CEP ${form.cep}` : null,
      ]
        .filter(Boolean)
        .join(", ");

      return endereco || form.endereco_cliente || "";
    },
    somenteNumeros(value) {
      return String(value || "").replace(/\D+/g, "");
    },
    formatDateTime(value) {
      return new Date(value).toLocaleString("pt-BR");
    },
    formatTime(value) {
      return new Date(value).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toDateTimeLocal(value) {
      if (!value) {
        return null;
      }

      const date = new Date(value);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString().slice(0, 16);
    },
    fromDateTimeLocal(value) {
      return value ? value.replace("T", " ") + ":00" : null;
    },
    dateFromDateTimeLocal(value) {
      return value ? value.slice(0, 10) : null;
    },
    apiError(error, fallback) {
      return (
        error?.response?.data?.msg || error?.response?.data?.message || fallback
      );
    },
    responseData(response) {
      const body = response && response.data ? response.data : response;
      return body && body.data ? body.data : body;
    },
    vendedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "vendedor");
    },
    desenvolvedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "desenvolvedor");
    },
    usuariosPorPapelFromAtribuicoes(response, papel) {
      const data = this.responseData(response);
      const usuarios =
        data && Array.isArray(data.usuarios) ? data.usuarios : [];

      return usuarios.filter((usuario) => {
        const papeis = Array.isArray(usuario.papeis_crm)
          ? usuario.papeis_crm
          : [];

        return usuario.selecionado || papeis.includes(papel);
      });
    },
    usuarioPorId(idUsuario) {
      const id = Number(idUsuario);
      const listas = [
        this.usuarios,
        this.vendedoresAtribuicao,
        this.desenvolvedoresAtribuicao,
        this.treinamentoAtribuicao,
      ];

      return listas
        .flat()
        .find((usuario) => Number(usuario.id_usuario) === id);
    },
    usuarioPossuiPapelCrm(idUsuario, papel) {
      const usuario = this.usuarioPorId(idUsuario);
      const papeis = Array.isArray(usuario && usuario.papeis_crm)
        ? usuario.papeis_crm
        : [];

      return papeis.includes(papel);
    },
    funilAtualChavePreset() {
      const funil =
        this.funis.find(
          (item) => Number(item.id_crm_funil) === Number(this.funilAtualId)
        ) || (this.kanban ? this.kanban.funil : null);

      return funil ? funil.chave_preset : null;
    },
    usuarioTemAcessoPorPapelAoFunilAtual(idUsuario) {
      const mapa = {
        vendas: ["vendedor", "desenvolvedor"],
        vendas_cliente_final: ["vendedor", "desenvolvedor"],
        pos_venda: ["vendedor"],
        implementacao_white_label: ["desenvolvedor"],
        treinamento_cliente_final: ["treinamento_cliente_final", "treinamento"],
        treinamento: ["treinamento"],
        website: ["website"],
      };
      const papeis = mapa[this.funilAtualChavePreset()] || [];

      return papeis.some((papel) => this.usuarioPossuiPapelCrm(idUsuario, papel));
    },
    isTreinamentoClienteFinal(oportunidade) {
      return (
        oportunidade && oportunidade.tipo_fluxo === "treinamento_cliente_final"
      );
    },
    idPrimeiroResponsavelTreinamento() {
      const primeiro = this.treinamentoResponsavelOptions.find(
        (option) => option.value
      );

      return primeiro ? primeiro.value : null;
    },
  },
};
